import './footer.less';

// trim-below
import React, {Component} from 'react';
import block from 'bem-cn-lite';

const b = block('footer');

import data from './footer';
import services from './services';

export default class Footer extends Component {
	render() {
		return (
			<footer className={b()}>
				<div className={b('top')}>
					<div className={b('container')}>
						<div className={b('info')}>
							<span className={b('logo')}></span>
							<span className={b('text')}>Μεταλλικες κατασκευες ηρακλειο κρητης</span>
						</div>
						<div className={b('services')}>
							<div className={b('title')}>Υπηρεσίες</div>
							<div className={b('list')}>
								{
									services.map((item, index) => {
										return(
											<div key={index} className={b('item')}>
												<a className={b('link')} href={item.link} title={item.title}>{item.title}</a>
											</div>
										);
									})
								}
							</div>
						</div>
						<div className={b('contacts')}>
							<div className={b('title')}>Επικοινωνία</div>
							<div className={b('list')}>
								<div className={b('item', {tel: true})}>
									Τηλέφωνο: <a className={b('link')} href="tel:+302810284040">2810 284040</a>
								</div>
								<div className={b('item', {email: true})}>
									E-mail: <a className={b('link')} href="mailto:info@skouras.eu">info@skouras.eu</a>
								</div>
								<div className={b('item', {address: true})}>
									Γραφεία: Κνωσού 15, Ηράκλειο
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className={b('bottom')}>
					<div className={b('container')}>
						<div className={b('nav')}>
							{
								data.map((item, index) => {
									return(
										<div key={index} className={b('item')}>
											<a className={b('link')} href={item.link} title={item.title}>{item.title}</a>
										</div>
									);
								})
							}
						</div>
						<span className={b('copyright')}>Copyright 2018 &copy; SQ ΣΚΟΥΡΑΣ</span>
					</div>
				</div>
			</footer>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/footer/index.jsx